
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/featured-creators",
      function () {
        return require("private-next-pages/featured-creators.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/featured-creators"])
      });
    }
  